// import React from 'react';
// import './ResourceSelector.css';

// const resources = [
//   {
//     id: 'asst_OYEGqG4j2LJizAd29TNWdKeU',
//     name: 'PaliGPT - 001',
//     title: 'The Problem of Evil: A Multifaceted Islamic Solution',
//     description: 'Explore Islamic perspectives on the problem of evil'
//   },
//   {
//     id: 'asst_ORtx8UWdX8OjsLVT0JdLp0vw',
//     name: 'PaliGPT - 002',
//     title: 'Intersectionality and Palestine Solidarity',
//     description: 'Why Muslims Need to Lead the Gaza Protests'
//   },
//   {
//     id: 'asst_GqX0ylTRKsIbW1uvKUjFJZsV',
//     name: 'PaliGPT - 003',
//     title: 'What Is Wrong with the International Holocaust Remembrance Alliance\'s Definition of Antisemitism?',
//     description: 'Analysis of IHRA definition - PMC'
//   },
//   {
//     id: 'asst_5OXfkaIGuml5MPuy2KZ8biIt',
//     name: 'PaliGPT - 004',
//     title: 'When Malcolm X visited Gaza in September 1964',
//     description: 'Historical analysis of Malcolm X\'s visit to Gaza'
//   },
//   {
//     id: 'asst_hNfWQd70TWGinBafH2FsQ7rX',
//     name: 'PaliGPT - 005',
//     title: 'The 100 Years\' War on Palestine by Rashid Khalidi',
//     description: 'Analysis of Rashid Khalidi\'s book'
//   }
// ];

// const paliGPTApiKeyMap = {
//   'asst_OYEGqG4j2LJizAd29TNWdKeU': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_001,
//   'asst_ORtx8UWdX8OjsLVT0JdLp0vw': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_002,
//   'asst_GqX0ylTRKsIbW1uvKUjFJZsV': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_003,
//   'asst_5OXfkaIGuml5MPuy2KZ8biIt': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_004,
//   'asst_hNfWQd70TWGinBafH2FsQ7rX': process.env.REACT_APP_OPENAI_API_KEY_PALIGPT_005,
// };

// const ResourceSelector = ({ onSelect, selectedResource }) => {
//   return (
//     <div className="resource-selector">
//       <div className="resource-selector-header">
//         <h3>Select Resource</h3>
//         <p className="resource-selector-subtitle">Choose a resource to query:</p>
//       </div>
//       <div className="resource-list">
//         {resources.map((resource) => (
//           <div
//             key={resource.id}
//             className={`resource-item ${selectedResource === resource.id ? 'selected' : ''}`}
//             onClick={() => onSelect(resource.id)}
//           >
//             <div className="resource-item-header">
//               <h4>{resource.name}</h4>
//             </div>
//             <div className="resource-item-content">
//               <h5>{resource.title}</h5>
//               <p>{resource.description}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ResourceSelector; 